import React from 'react';
import { Table as MuiTable, TableContainer, Paper } from '@mui/material';
export default function Table(_a) {
    var children = _a.children;
    return (React.createElement(TableContainer, { sx: { marginTop: 4, borderRadius: 2 }, component: Paper },
        React.createElement(MuiTable, null, children)));
}
